import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';
import { FiltersSection } from '../FiltersSection';
import { RangeFilter } from '../../../../ui/RangeFilter';
import { RangeFilterWrapper } from '../styled';

export const NewSearchArea = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const isLand = values.category_id === '9';

  const title = `${t('search.form.area').slice(0, -1)} (${
    isLand ? t('search.form.units.acres') : t('search.form.units.metres')
  })`;

  return (
    <FiltersSection title={title}>
      <RangeFilterWrapper>
        <RangeFilter
          minName="area_from"
          minId="new-search-form-area-from"
          maxId="new-search-form-area-to"
          maxName="area_to"
          rangeInFilterModal
        />
      </RangeFilterWrapper>
    </FiltersSection>
  );
};
